export class Sip {
    public server!: string;
    public routes!: string[] | undefined;
    public displayName!: string;
    public publicIdentity!: string;
    public privateIdentity!: string;
    public password!: string;
    public realm!: string;
    public iceUrls!: string[] | undefined;
}

